import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http'
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrestashopService {

  constructor(private http : HttpClient) { }

  url = 'https://www.john-steel.com/api/'
  key = "ULD543KEF4RUU6FSYGM8DSJWZD2DY8FE"
  url_addons = "&output_format=JSON";

  buildUrl(type, start, end, shopId){
    return this.url+'/'+type+'?ws_key='+this.key+'&start='+start+'&end='+end+'&id_boutique='+shopId+this.url_addons;
  }

  getData(api, start, end, shopId){
    return this.http.get(this.buildUrl(api, start, end,shopId));
  }
}
